<template>
  <div class="home-news">
    <h1 class="news-header">
      通知公告
      <router-link to="./notice" class="more-link pull-right" replace>
        查看更多
        <a-icon type="double-right" style="padding-right: 12px;" />
      </router-link>
    </h1>
    <div class="clearfix"></div>
    <a-spin :spinning="noticeSpinning">
      <ul class="home-news-ul" v-if="list.length">
        <li v-for="item of list" :key="item.id">
          <router-link :to="`/detail/${item.id}?type=notify`">
            <div class="news-detail">
              <span class="news-title ellipsis">{{ item.title }}</span>
              <span class="type-tag" :class="typeTagClass(item.notifyType)">
                {{ typeText(item.notifyType) }}
              </span>
              <span class="pull-right time-tag">{{ item.publishTime }}</span>
            </div>
          </router-link>
        </li>
      </ul>
      <ul v-else class="home-news-ul">
        无通知公告
      </ul>
    </a-spin>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: 'HomeNews',
  data: function() {
    return {
      list: [],
      noticeSpinning: true,
    };
  },
  created() {
    if (localStorage.getItem('token')) {
      this.axios.get(`/biz/home/notify/list`, { params: { pageNo: 1, pageSize: 4 } }).then(res => {
        this.noticeSpinning = false;
        if (res.result.records) {
          this.list = res.result.records.slice(0, 4);
        }
      });
    } else {
      this.common.toURL('/login');
    }
  },
  methods: {
    /**
     * 通知类型文本
     */
    typeText(type) {
      const typeMap = { 0: '通知', 1: '督导', 2: '公告' };
      return typeMap[type] || '';
    },

    /**
     * 通知label样式
     */
    typeTagClass(type) {
      const classMap = { 0: 'tag-notice', 1: 'tag-urge', 2: 'tag-public' };
      return classMap[type] || '';
    },

    /**
     * 跳转通知详情页
     */
    gotoDetail(id) {
      this.$router.push({ name: '/detail/', params: { id, type: 'notify' } });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'

.home-news {
  padding: 16px 0;
  margin: 0 auto;

  .news-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  .more-link {
    padding-top: 3px;
    color: #999;
    font-size: 14px;
    font-weight: normal;
    display: inline-flex;
    align-items: center;
  }

  .home-news-ul {
    background: #fff;
    padding: 16px;
    height: 150px;
    overflow-y: hidden;

    li {
      a {
        color: #333;

        &:hover {
          text-decoration: none;
          color: $bgColor;
        }

        .news-detail {
          margin-bottom: 18px;
          display: flex;

          .news-title {
            flex: 1;
            padding-right: 20px;
            font-size: 15px;
          }

          .type-tag {
            display: inline-block;
            padding: 2px 6px;
            margin-right: 12px;
            font-size: 12px;
            border-radius: 4px;
            color: #fff;
            background-color: #909399;

            &.tag-notice {
              background-color: #409eff;
            }

            &.tag-urge {
              background-color: #f56c6c;
            }

            &.tag-public {
              background-color: #67c23a;
            }
          }

          .time-tag {
            width: auto;
            text-align: center;
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/News.vue